module.exports = __webpack_public_path__ + "static/media/winter_super_pack_cat_bed_EN.b54ddebf.png";